import SimpleBar from 'simplebar';

new SimpleBar(document.getElementById('iti-0__country-listbox'));


